import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UploadStatus, UploadType } from '@sc/data-access-models';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FileHttpService {
  private readonly getFileUploadStatusUrl = `/api/partners/files/<type>/status`;
  private readonly fileDownloadUrl = `/api/file/download/<fileFolder>/<fileName>`;
  private readonly downloadTimeout = '10000';
  constructor(private readonly httpClient: HttpClient) {}

  getFileUploadStatus(uploadType: UploadType): Observable<UploadStatus> {
    return this.httpClient.get<UploadStatus>(
      this.getFileUploadStatusUrl.replace('<type>', uploadType),
      {
        headers: {
          requestName: 'file-http getFileUploadStatus',
          'Cache-Control': 'public, max-age=1',
        },
      }
    );
  }

  downloadFile(url: string, fileDir = 'damagepictures') {
    const docURL = new URL(url);
    const pathNameSplit = docURL.pathname.split('/');
    return this.httpClient.get(
      this.fileDownloadUrl
        .replace('<fileFolder>', fileDir)
        .replace('<fileName>', pathNameSplit[pathNameSplit.length - 1]) +
        docURL.search,
      {
        responseType: 'blob',
        headers: {
          timeout: this.downloadTimeout,
        },
      }
    );
  }
}
